import React from 'react';
import PropTypes from 'prop-types';
import parseGGDriver from '../../../helpers/parseGGDriver';
import { LazyLoadImage } from 'react-lazy-load-image-component';

class MockUpBackCol extends React.PureComponent {

    render() {
        const { mockUpBack } = this.props

        const _mockUpBack = parseGGDriver(mockUpBack || '');
        
        return (
            <div className="MockUpBack">
                {_mockUpBack &&
                <a href={mockUpBack} target="_blank">
                    <LazyLoadImage className='zoom' src={_mockUpBack} alt='Link' />
                </a>
                }
            </div>
        );
    }
}

MockUpBackCol.propTypes = {
    mockUpBack: PropTypes.string,
};

export default MockUpBackCol;
